import { P } from 'components'
import PropTypes from 'prop-types'

const PMBTabSwitcher = ({
  activeTab,
  tabs,
  onTabChange,
  boldLabel = false,
  labelSize = 'regular',
  className,
  testId = 'pmb-tab-switcher',
  variant = 'underline',
}) => {
  if (variant === 'pills') {
    return (
      <div
        className={className ?? 'd-inline-flex align-items-center p-1 rounded-3 mb-3'}
        style={{
          backgroundColor: '#F2F4F7',
          border: '1px solid #E4E7EC',
          gap: '4px',
        }}
      >
        {tabs?.map((tab) => {
          const isActive =
            activeTab === tab.key ||
            (tab.key !== '/farmers' && activeTab?.startsWith(tab.key))

          return (
            <button
              key={tab.key}
              type="button"
              data-testid={`${testId}-${tab.key}`}
              style={{
                backgroundColor: isActive ? '#005370' : 'transparent',
                color: isActive ? '#FFFFFF' : '#475467',
                borderRadius: '6px',
                padding: '7px 18px',
                cursor: 'pointer',
                fontWeight: isActive ? 600 : 500,
                fontSize: '14px',
                border: 'none',
                outline: 'none',
                transition: 'all 0.2s ease',
                boxShadow: isActive ? '0 1px 3px rgba(0, 83, 112, 0.25)' : 'none',
                userSelect: 'none',
                whiteSpace: 'nowrap',
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor = '#E4E7EC'
                  e.currentTarget.style.color = '#1D2939'
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.backgroundColor = 'transparent'
                  e.currentTarget.style.color = '#475467'
                }
              }}
              onClick={() => onTabChange(tab.key)}
            >
              {tab.label}
            </button>
          )
        })}
      </div>
    )
  }

  return (
    <div
      className={className ?? 'd-flex gap-3 mb-3'}
      style={{ borderBottom: '1px solid #EAECF0' }}
    >
      {tabs?.map((tab) => {
        const isActive = activeTab === tab.key
        return (
          <div
            key={tab.key}
            data-testid={`${testId}-${tab.key}`}
            style={{
              borderBottom: isActive ? '2px solid #005370' : '',
              paddingBottom: 14,
              color: isActive ? '#005370' : '#667085',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: isActive ? 600 : boldLabel ? 600 : 400,
            }}
            onClick={() => onTabChange(tab.key)}
          >
            <P size={labelSize} bold={boldLabel || isActive}>
              {tab.label}
            </P>
          </div>
        )
      })}
    </div>
  )
}

PMBTabSwitcher.propTypes = {
  activeTab: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onTabChange: PropTypes.func.isRequired,
  boldLabel: PropTypes.bool,
  labelSize: PropTypes.string,
  className: PropTypes.string,
  testId: PropTypes.string,
  variant: PropTypes.oneOf(['underline', 'pills']),
}

PMBTabSwitcher.defaultProps = {
  boldLabel: false,
  labelSize: 'regular',
  className: undefined,
  testId: 'pmb-tab-switcher',
  variant: 'underline',
}

export default PMBTabSwitcher
